import { FormBeps } from "../../../../../../models/Beps/beps.model";
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import { ChangeEvent, useEffect, useState } from "react";

type SisbenEducativoProps = {
  formBeps: FormBeps;
  setFormBeps: Function;
  tab: any;
  nextTab: any;
  prevTab: any;
  actualizarFormulario: any;
};

export const SisbenEducativo = ({
  formBeps,
  setFormBeps,
  tab,
  nextTab,
  prevTab,
  actualizarFormulario,
}: SisbenEducativoProps) => {
  useEffect(() => {
    console.log(formBeps);
    if (formBeps.sisben) {
      setIsSisben(true);
    } else {
      setIsSisben(false);
    }
    if (formBeps.listado_censal) {
      setIsListadoCensal(true);
    } else {
      setIsListadoCensal(false);
    }
    if (formBeps.area_id == 11) {
      setIsOtraArea(true);
    } else {
      setIsOtraArea(false);
    }
    if (formBeps.principal_actividad_id == 11) {
      setIsOtraActividadPrincioal(true);
    } else {
      setIsOtraActividadPrincioal(false);
    }
    if (formBeps.desarrolla_actividad) {
      setIsDesarrollaActividad(true);
    } else {
      setIsDesarrollaActividad(false);
    }

    if (formBeps.tipo_contrato) {
      setIsTipoContrato(true);
    } else {
      setIsTipoContrato(false);
    }
  }, []);

  let fields = [
    { name: "sisben", value: formBeps.sisben },
    { name: "puntaje_sisben", value: formBeps.puntaje_sisben },
    { name: "listado_censal", value: formBeps.listado_censal },
    { name: "listado_censal_cual", value: formBeps.listado_censal_cual },
    { name: "seguridad_social_regimen_id", value: formBeps.seguridad_social_regimen_id },
    { name: "nivel_educativo_id", value: formBeps.nivel_educativo_id },
    { name: "area_id", value: formBeps.area_id },
    { name: "otra_area", value: formBeps.otra_area },
    { name: "tipo_ingresos", value: formBeps.tipo_ingresos },
    { name: "principal_actividad_id", value: formBeps.principal_actividad_id },
    { name: "principal_actividad_cual", value: formBeps.principal_actividad_cual },
    { name: "tiempo_actividad_principal", value: formBeps.tiempo_actividad_principal },
    { name: "desarrolla_actividad", value: formBeps.desarrolla_actividad },
    { name: "actividad_actual", value: formBeps.actividad_actual },
    { name: "actividad_actual_cual", value: formBeps.actividad_actual_cual },
    { name: "tiempo_actividad_actual", value: formBeps.tiempo_actividad_actual },
    { name: "tipo_contrato", value: formBeps.tipo_contrato },
    { name: "contrato", value: formBeps.contrato },
  ];

  const [isSisben, setIsSisben] = useState(false);
  const handleSisbenChange = ({ target }: any) => {
    if (target.value) {
      setIsSisben(true);
    } else {
      setIsSisben(false);
    }
  };

  const [isListadoCensal, setIsListadoCensal] = useState(false);
  const handleListadoCensalChange = ({ target }: any) => {
    if (target.value) {
      setIsListadoCensal(true);
    } else {
      setIsListadoCensal(false);
    }
  };

  const [isOtraArea, setIsOtraArea] = useState(false);
  const handleOtraAreaChange = (value: number) => {
    if (value == 11) {
      setIsOtraArea(true);
    } else {
      setIsOtraArea(false);
    }
  };

  const [isOtraActividadPrincioal, setIsOtraActividadPrincioal] = useState(false);
  const handlePrincipalActividadChange = (value: number) => {
    if (value == 11) {
      setIsOtraActividadPrincioal(true);
    } else {
      setIsOtraActividadPrincioal(false);
    }
  };

  const [isDesarrollaActividad, setIsDesarrollaActividad] = useState(false);
  const handleDesarrollaActividadChange = ({ target }: any) => {
    if (target.value) {
      setIsDesarrollaActividad(false);
      setIsOtraActividadActual(false);
    } else {
      setIsDesarrollaActividad(true);
    }
  };

  const [isOtraActividadActual, setIsOtraActividadActual] = useState(false);
  const handleActividadActualChange = (value: number) => {
    if (value == 11) {
      setIsOtraActividadActual(true);
    } else {
      setIsOtraActividadActual(false);
    }
  };

  const [isTipoContrato, setIsTipoContrato] = useState(false);
  const handleTipoContratoChange = async ({ target }: any) => {
    if (target.value) {
      setIsTipoContrato(true);
    } else {
      setIsTipoContrato(false);
    }
  };

  return (
    <Form
      size="large"
      fields={fields}
      name="formSisben"
      onFieldsChange={(_, fields: any) => {
        let infoupdate: any = { ...formBeps };
        for (var i in fields) {
          infoupdate[fields[i].name] = fields[i].value;
        }
        setFormBeps(infoupdate);
      }}
      onFinish={actualizarFormulario}
    >
      <div className="row mb-4">
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Tiene sisbén
          </span>
          <Form.Item className="no-margin" name="sisben" rules={[{ required: true, message: "Campo obligatorio" }]}>
            <Radio.Group value={formBeps.sisben} onChange={handleSisbenChange}>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        {isSisben ? (
          <div className="col-12 col-md-6 col-lg-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Puntaje sisben
            </span>
            <Form.Item className="no-margin" name="puntaje_sisben" rules={[{ required: true, message: "" }]}>
              <Select placeholder="Seleccionar..." value={formBeps.puntaje_sisben}>
                <Select.Option value="A1">A1</Select.Option>
                <Select.Option value="A2">A2</Select.Option>
                <Select.Option value="A3">A3</Select.Option>
                <Select.Option value="A4">A4</Select.Option>
                <Select.Option value="A5">A5</Select.Option>
                <Select.Option value="B1">B1</Select.Option>
                <Select.Option value="B2">B2</Select.Option>
                <Select.Option value="B3">B3</Select.Option>
                <Select.Option value="B4">B4</Select.Option>
                <Select.Option value="B5">B5</Select.Option>
                <Select.Option value="B6">B6</Select.Option>
                <Select.Option value="B7">B7</Select.Option>
                <Select.Option value="C1">C1</Select.Option>
                <Select.Option value="C2">C2</Select.Option>
                <Select.Option value="C3">C3</Select.Option>
                <Select.Option value="C4">C4</Select.Option>
                <Select.Option value="C5">C5</Select.Option>
                <Select.Option value="C6">C6</Select.Option>
                <Select.Option value="C7">C7</Select.Option>
                <Select.Option value="C8">C8</Select.Option>
                <Select.Option value="C9">C9</Select.Option>
                <Select.Option value="C10">C10</Select.Option>
                <Select.Option value="C11">C11</Select.Option>
                <Select.Option value="C12">C12</Select.Option>
                <Select.Option value="C13">C13</Select.Option>
                <Select.Option value="C14">C14</Select.Option>
                <Select.Option value="C15">C15</Select.Option>
                <Select.Option value="C16">C16</Select.Option>
                <Select.Option value="C17">C17</Select.Option>
                <Select.Option value="C18">C18</Select.Option>
                <Select.Option value="D1">D1</Select.Option>
                <Select.Option value="D2">D2</Select.Option>
                <Select.Option value="D3">D3</Select.Option>
                <Select.Option value="D4">D4</Select.Option>
                <Select.Option value="D5">D5</Select.Option>
                <Select.Option value="D6">D6</Select.Option>
                <Select.Option value="D7">D7</Select.Option>
                <Select.Option value="D8">D8</Select.Option>
                <Select.Option value="D9">D9</Select.Option>
                <Select.Option value="D10">D10</Select.Option>
                <Select.Option value="D11">D11</Select.Option>
                <Select.Option value="D12">D12</Select.Option>
                <Select.Option value="D13">D13</Select.Option>
                <Select.Option value="D14">D14</Select.Option>
                <Select.Option value="D15">D15</Select.Option>
                <Select.Option value="D16">D16</Select.Option>
                <Select.Option value="D17">D17</Select.Option>
                <Select.Option value="D18">D18</Select.Option>
                <Select.Option value="D19">D19</Select.Option>
                <Select.Option value="D20">D20</Select.Option>
                <Select.Option value="D21">D21</Select.Option>
              </Select>
            </Form.Item>
          </div>
        ) : (
          <div className="col-12 col-md-6 col-lg-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Régimen de seguridad social
            </span>
            <Form.Item
              className="no-margin"
              name="seguridad_social_regimen_id"
              rules={[{ required: true, message: "" }]}
            >
              <Select placeholder="Seleccionar..." value={formBeps.seguridad_social_regimen_id}>
                <Select.Option value={1}>Subsidiado</Select.Option>
                <Select.Option value={2}>Contribuyente - Cotizante</Select.Option>
                <Select.Option value={3}>Contribuyente - Beneficiario</Select.Option>
              </Select>
            </Form.Item>
          </div>
        )}
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Hace parte de un listado censal
          </span>
          <Form.Item className="no-margin" name="listado_censal" rules={[{ required: true, message: "Campo obligatorio" }]}>
            <Radio.Group value={formBeps.listado_censal} onChange={handleListadoCensalChange}>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        {isListadoCensal && (
          <div className="col-12 col-md-6 col-lg-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Listado censal al que pertenece
            </span>
            <Form.Item className="no-margin" name="listado_censal_cual" rules={[{ required: true, message: "" }]}>
              <Select placeholder="Seleccionar..." value={formBeps.listado_censal_cual}>
                <Select.Option value={"Víctimas del conflicto armado interno"}>Víctimas del conflicto armado interno</Select.Option>
                <Select.Option value={"Comunidades indígenas"}>Comunidades indígenas</Select.Option>
                <Select.Option value={"Migrante venezolano con PEP e hijos menores de edad con documento válido"}>Migrante venezolano con PEP e hijos menores de edad con documento válido</Select.Option>
                <Select.Option value={"Adulto mator en centros de protección"}>Adulto mator en centros de protección</Select.Option>
                <Select.Option value={"Población infantil abandonada a cargo del instituto divombianode Bienestar Familiar"}>Población infantil abandonada a cargo del instituto divombianode Bienestar Familiar</Select.Option>
                <Select.Option value={"Los voluntarios acreditados y activaos de la defensa Civil, Cruz Roja y Cuerpos de Bomberos y su núcleo familiar"}>Los voluntarios acreditados y activaos de la defensa Civil, Cruz Roja y Cuerpos de Bomberos y su núcleo familiar</Select.Option>
                <Select.Option value={"Habitante de la calle"}>Habitante de la calle</Select.Option>
                <Select.Option value={"Migrantes colombianos repatriados que han retornado voluntariamente al país o han sido deportados o expulsados de territorio extranjero"}>Migrantes colombianos repatriados que han retornado voluntariamente al país o han sido deportados o expulsados de territorio extranjero</Select.Option>
                <Select.Option value={"Población desmovilizada y/o miembros del grupo armado ilegal que celebren acuerdos de paz con el Gobierno Nacional"}>Población desmovilizada y/o miembros del grupo armado ilegal que celebren acuerdos de paz con el Gobierno Nacional</Select.Option>
                <Select.Option value={"Personas en prisión domiciliaria a cargo del INPEC"}>Personas en prisión domiciliaria a cargo del INPEC</Select.Option>
                <Select.Option value={"Población infantil vulnerable bajo protección de instituciones diferentes al ICBF"}>Población infantil vulnerable bajo protección de instituciones diferentes al ICBF</Select.Option>
                <Select.Option value={"Recién nacidos y menores de edad de padres no afiliados"}>Recién nacidos y menores de edad de padres no afiliados</Select.Option>
                <Select.Option value={"Adolescentes y jóvenes a cargo del ICBF en el sistema de responsabilidad penal para adolecentes"}>Adolescentes y jóvenes a cargo del ICBF en el sistema de responsabilidad penal para adolecentes</Select.Option>
                <Select.Option value={"Población reclusa a cargo de la entidad territorial"}>Población reclusa a cargo de la entidad territorial</Select.Option>
                <Select.Option value={"Programa en protección a testigos"}>Programa en protección a testigos</Select.Option>
                <Select.Option value={"Personas que dejen de ser madres comunitarias"}>Personas que dejen de ser madres comunitarias</Select.Option>
                <Select.Option value={"Personas con discapacidad de escasos recursos y en condición de abandono en centros de protección"}>Personas con discapacidad de escasos recursos y en condición de abandono en centros de protección</Select.Option>
                <Select.Option value={"Rrom (Gitano)"}>Rrom (Gitano)</Select.Option>
                <Select.Option value={"Personas que se encuentran detenidas sin condena o cumpliendo medida de aseguramiento en centro de detención transitoria"}>Personas que se encuentran detenidas sin condena o cumpliendo medida de aseguramiento en centros de detención transitoria</Select.Option>
                <Select.Option value={"Menores desvinculados del conflicto armado bajo la proteccióndel ICBF"}>Menores desvinculados del conflicto armado bajo la proteccióndel ICBF</Select.Option>

              </Select>
            </Form.Item>
          </div>
        )}
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Nivel educativo
          </span>
          <Form.Item className="no-margin" name="nivel_educativo_id" rules={[{ required: true, message: "" }]}>
            <Select placeholder="Seleccionar..." value={formBeps.nivel_educativo_id}>
              <Select.Option value={1}>Primaria</Select.Option>
              <Select.Option value={2}>Bachillerato</Select.Option>
              <Select.Option value={3}>Técnico</Select.Option>
              <Select.Option value={4}>Tecnólogo</Select.Option>
              <Select.Option value={5}>Pregrado</Select.Option>
              <Select.Option value={6}>Posgrado</Select.Option>
              <Select.Option value={7}>Ninguno</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Tipo ingresos
          </span>
          <Form.Item className="no-margin" name="tipo_ingresos" rules={[{ required: true, message: "" }]}>
            <Select placeholder="Seleccionar..." value={formBeps.tipo_ingresos}>
              <Select.Option value={1}>Menor al salario minimo mensual</Select.Option>
              <Select.Option value={2}>Igual al salario minimo mensual</Select.Option>
              <Select.Option value={3}>Mayor al salario minimo mensual</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            ¿Tiene contrato?
          </span>
          <Form.Item className="no-margin" name="tipo_contrato" rules={[{ required: true, message: "Campo obligatorio" }]}>
            <Radio.Group value={formBeps.tipo_contrato} onChange={handleTipoContratoChange}>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        {isTipoContrato && (
          <div className="col-12 col-md-6 col-lg-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Tipo Contrato
            </span>
            <Form.Item className="no-margin" name="contrato" rules={[{ required: true, message: "" }]}>
              <Input value={formBeps.contrato} />
            </Form.Item>
          </div>
        )}
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Área
          </span>
          <Form.Item className="no-margin" name="area_id" rules={[{ required: true, message: "" }]}>
            <Select placeholder="Seleccionar..." value={formBeps.area_id} onChange={handleOtraAreaChange}>
              <Select.Option value={1}>Teatro</Select.Option>
              <Select.Option value={2}>Música</Select.Option>
              <Select.Option value={3}>Danza</Select.Option>
              <Select.Option value={4}>Circo</Select.Option>
              <Select.Option value={5}>Artes Plásticas</Select.Option>
              <Select.Option value={6}>Artes Visuales</Select.Option>
              <Select.Option value={7}>Cine</Select.Option>
              <Select.Option value={8}>Artesanos</Select.Option>
              <Select.Option value={9}>Literatura</Select.Option>
              <Select.Option value={10}>Gestion Cultural</Select.Option>
              <Select.Option value={11}>Otra</Select.Option>
              <Select.Option value={12}>Ninguna</Select.Option>
              <Select.Option value={13}>Oficios tradicionales</Select.Option>
              <Select.Option value={14}>Portador manifestación patrimonio cultural inmaterial</Select.Option>
            </Select>
          </Form.Item>
        </div>

        {isOtraArea && (
          <div className="col-12 col-md-6 col-lg-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Otra ¿Cuál?
            </span>
            <Form.Item className="no-margin" name="otra_area" rules={[{ required: true, message: "" }]}>
              <Input value={formBeps.otra_area} />
            </Form.Item>
          </div>
        )}
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Actividad de creación o gestión en la que se ha desempeñado
          </span>
          <Form.Item 
          className="no-margin" name="principal_actividad_id" rules={[{ required: true, message: "" }]}>
            <Select
              placeholder="Seleccionar..."
              value={formBeps.principal_actividad_id}
              onChange={handlePrincipalActividadChange}
            >
              <Select.Option value={1}>Teatro</Select.Option>
              <Select.Option value={2}>Música</Select.Option>
              <Select.Option value={3}>Danza</Select.Option>
              <Select.Option value={4}>Circo</Select.Option>
              <Select.Option value={5}>Artes Plásticas</Select.Option>
              <Select.Option value={6}>Artes Visuales</Select.Option>
              <Select.Option value={7}>Cine</Select.Option>
              <Select.Option value={8}>Artesanos</Select.Option>
              <Select.Option value={9}>Literatura</Select.Option>
              <Select.Option value={10}>Gestion Cultural</Select.Option>
              <Select.Option value={11}>Otra</Select.Option>
              <Select.Option value={12}>Ninguna</Select.Option>
              <Select.Option value={13}>Oficios tradicionales</Select.Option>
              <Select.Option value={14}>Portador manifestación patrimonio cultural inmaterial</Select.Option>
            </Select>
          </Form.Item>
        </div>
        {isOtraActividadPrincioal && (
          <div className="col-12 col-md-6 col-lg-4 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Otra
            </span>
            <Form.Item className="no-margin" name="principal_actividad_cual" rules={[{ required: true, message: "" }]}>
              <Input value={formBeps.principal_actividad_cual} />
            </Form.Item>
          </div>
        )}
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Tiempo dedicado a la actividad señalada (Meses)
          </span>
          <Form.Item className="no-margin" name="tiempo_actividad_principal" rules={[{ required: true, message: "Campo obligatorio" }, { pattern: /^[1-9][0-9]*$/, message: "No se pueden ingresar valores nulos o negativos" }]}>
            <Input type="number" value={formBeps.tiempo_actividad_principal} />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-4">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
            Se desempeña actualmente en esta actividad
          </span>
          <Form.Item className="no-margin" name="desarrolla_actividad" rules={[{ required: true, message: "Campo obligatorio" }]}>
            <Radio.Group value={formBeps.desarrolla_actividad} onChange={handleDesarrollaActividadChange}>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        {isDesarrollaActividad && (
          <>
            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                Actividad de creación o gestión en la  que desempeña actualmente
              </span>
              <Form.Item className="no-margin" name="actividad_actual" rules={[{ required: true, message: "Campo obligatorio" }]}>
                <Select
                  placeholder="Seleccionar..."
                  value={formBeps.actividad_actual}
                  onChange={handleActividadActualChange}
                >
                  <Select.Option value={1}>Teatro</Select.Option>
                  <Select.Option value={2}>Música</Select.Option>
                  <Select.Option value={3}>Danza</Select.Option>
                  <Select.Option value={4}>Circo</Select.Option>
                  <Select.Option value={5}>Artes Plásticas</Select.Option>
                  <Select.Option value={6}>Artes Visuales</Select.Option>
                  <Select.Option value={7}>Cine</Select.Option>
                  <Select.Option value={8}>Artesanos</Select.Option>
                  <Select.Option value={9}>Literatura</Select.Option>
                  <Select.Option value={10}>Gestion Cultural</Select.Option>
                  <Select.Option value={11}>Otra</Select.Option>
                  <Select.Option value={12}>Ninguna</Select.Option>
                  <Select.Option value={13}>Oficios tradicionales</Select.Option>
                  <Select.Option value={14}>Portador manifestación patrimonio cultural inmaterial</Select.Option>
                </Select>
              </Form.Item>
            </div>

            {isOtraActividadActual && (
              <div className="col-12 col-md-6 col-lg-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                  Otra
                </span>
                <Form.Item className="no-margin" name="actividad_actual_cual" rules={[{ required: true, message: "" }]}>
                  <Input value={formBeps.actividad_actual_cual} />
                </Form.Item>
              </div>
            )}

            <div className="col-12 col-md-6 col-lg-3 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                Tiempo dedicado a la actividad actual (Meses)
              </span>
              <Form.Item className="no-margin" name="tiempo_actividad_actual" rules={[{ required: true, message: "" }, { pattern: /^[1-9][0-9]*$/, message: "No se pueden ingresar valores nulos o negativos" }]}>
                <Input type="number" value={formBeps.tiempo_actividad_actual} />
              </Form.Item>
            </div>
          </>
        )}
      </div>
      <div className="row no-margin" style={{ position: "sticky", bottom: 0 }}>
        <div className="m-0 p-0 justify-content-flex-end">
          <Button className="button-blanco-radius" onClick={prevTab} style={{ marginRight: "16px" }}>
            Atrás
          </Button>
          <Button className="button-azul-radius" form="formSisben" htmlType="submit">
            Guardar y continuar
          </Button>
        </div>
      </div>
    </Form>
  );
};
